import React, {
  useState,
} from 'react';
import PropTypes from 'prop-types';

import {
  Card,
} from '../../../../components/v2/Card';
import LoadingOverlay from '../../../components/LoadingOverlay';
import Accordion from '../../../../components/Accordion/Accordion';
import CoachInfoForm from './CoachInfoForm/CoachInfoForm';
import Promotions from './Promotions';

import texts from './texts';
import { StyledTitle } from './styles';

const CoachInfo = ({ coach: { id: coachId } }) => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <Card>
      <Accordion
        title={<StyledTitle>{texts.coachInformationTitle}</StyledTitle>}
        defaultExpanded
      >
        <CoachInfoForm
          coachId={coachId}
          setIsLoading={setIsLoading}
        />
      </Accordion>
      <Accordion
        title={<StyledTitle>{texts.promotionsTitle}</StyledTitle>}
      >
        <Promotions
          coachId={coachId}
        />
      </Accordion>
      <LoadingOverlay isLoading={isLoading} />
    </Card>
  );
};

CoachInfo.propTypes = {
  coach: PropTypes.object,
};

CoachInfo.defaultProps = {
  coach: {},
};

export default CoachInfo;
